<template>
  <div class="answer" :data-answer="answerText">
    <span>{{ answerId }}</span>
    {{ answerText }}
  </div>
</template>

<script>
export default {
  name: 'Answer',
  props: {
    answerId: String,
    answerText: String,
  }
}
</script>

<style lang="scss" scoped>
  .answer {
    background: linear-gradient( 0deg, rgb(212,180,225) 0%, rgb(255,255,255) 100%);
    color: #662d91;
    cursor: pointer;
    font-size: 26px;
    font-weight: bold;
    line-height: 95px;
    max-width: 100%;
    padding-left: 105px;
    position: relative;
    text-align: left;
    height: 95px;

    &.correct {
      span {
        background: url('../assets/correct.jpg') center center no-repeat;
        background-size: cover;
        height: 96px;
        text-indent: -999em;
        top: -1px;
        width: 77px;
      }
    }

    &.incorrect {
      span {
        background: url('../assets/incorrect.jpg') center center no-repeat;
        background-size: cover;
        height: 96px;
        text-indent: -999em;
        top: -1px;
        width: 77px;
      }
    }

    span {
      background: linear-gradient( 93deg, rgb(253,151,7) 27%, rgb(254,130,4) 47%, rgb(255,109,0) 69%);
      color: #fff;
      font-size: 36px;
      font-family: "Open Sans";
      font-weight: bold;
      line-height: 95px;
      height: 95px;
      left: 0;
      pointer-events: none;
      position: absolute;
      text-align: center;
      text-shadow: 1.5px 2.598px 0px rgba(0, 0, 0, 0.34);
      text-transform: uppercase;
      top: 0;
      width: 76px;
    }
  }
</style>
